.page {
  inline-size: min(100%, 90rem);
  min-block-size: 100dvh;
  margin-inline: auto;
  padding: clamp(var(--space-4), 4vw, var(--space-8));
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-8);
  padding-block-end: var(--space-6);
  border-block-end: 1px solid var(--color-border);
}

.brand {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.brand h1,
.brand p {
  margin: 0;
}

.brand h1 {
  font-size: clamp(1.5rem, 3vw, 2rem);
  letter-spacing: -0.04em;
}

.brand p {
  margin-block-start: 0.125rem;
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
}

.mark {
  display: grid;
  inline-size: 2.75rem;
  block-size: 2.75rem;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.1875rem;
  padding: 0.35rem;
  border-radius: var(--radius-small);
  background: var(--color-accent);
  box-shadow: var(--shadow-accent);
}

.mark span {
  border-radius: 0.125rem;
  background: var(--color-on-accent);
  opacity: 0.9;
}

.main {
  padding-block: clamp(var(--space-5), 5vw, var(--space-8));
}

@media (max-width: 43rem) {
  .page {
    padding: var(--space-4);
  }

  .header {
    align-items: flex-start;
    flex-direction: column;
    gap: var(--space-5);
  }

  .brand p {
    display: none;
  }
}
